import React from 'react';
import PropTypes from 'prop-types';
import PriorityBadge from './PriorityBadge';
import './styles/item-list.css';

/**
 * A component for displaying lists of items with priority badges
 * @param {Array} items - Array of items to display
 * @param {React.ReactNode} icon - Optional icon for each item
 */
export default function ItemList({ items, icon }) {
  if (!items?.length) return null;
  
  return (
    <ul className="item-list">
      {items.map((item, idx) => (
        <li key={idx} className="item-list-entry">
          <div className="item-content">
            {icon && <span className="item-icon">{icon}</span>}
            <div>
              {item.importance && <PriorityBadge level={item.importance} />}
              <p className="item-explanation">{item.explanation || item.description}</p>
              {item.scene_numbers?.length > 0 && (
                <div className="item-scenes">
                  Scenes: {item.scene_numbers.map(s => s.scene ?? s).join(', ')}
                </div>
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

ItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      importance: PropTypes.string,
      explanation: PropTypes.string,
      description: PropTypes.string,
      scene_numbers: PropTypes.array
    })
  ),
  icon: PropTypes.node
};